module.exports = function(bootstrap) {
    bootstrap.run(["Service", function (Service) {
        return new Service({

            name: 'planAdminInfo',
            group: "eprsvc",
            url: "/eprsvc/x-services/secure/planAdmin/v1/info/",
            cache: true,

            getPlanAdmin: function(loginId) {// to get plan admin info :GET
                this.url=this.url+loginId;
                return this.get();
            },
            updatePlanAdmin: function(loginId,params) { // to update plan admin info :PUT
                this.url=this.url+loginId;
                return this.put({
                    "payload": {
                        "planAdministrator" : params.demographicInfo,
                        "dataDifferentiator":params.dataDifferentiator,
                        "planAdministratorEntitlements": {
                            "clientId" : params.clientId,
                            "userLevelEntitlements": params.userLevelEntitlements,
                            "groupLevelEntitlements" : params.groupLevelEntitlements,
                            "customersWithDentalEntitlements" : params.dentalEntitlements
                        }
                    }
                });
            },
            clearCache: function(loginId) { // to update plan admin info :PUT
                this.url=this.url+loginId;
                return this.flushCache();
            }
        });
    }]);
};
